// extracted by mini-css-extract-plugin
export var clone = "_sg-2";
export var displayNone = "_sg-4";
export var expandableItem = "_sg-5";
export var expanded = "_sg-6";
export var folderItem = "_sg-7";
export var ghost = "_sg-1";
export var hidden = "_sg-3";
export var pipeContainer = "_sg-8";
export var wrapper = "_sg-0";